import React from 'react';

import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

interface Props {
	json: any;
	maxHeight?: number;
}
const JSONBlock = (props: Props) => {
	const classes = useStyles(props);
	return (
		<div className={classes.wrapper}>
			<pre className={classes.inner}>{JSON.stringify(props.json, null, 2)}</pre>
		</div>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		wrapper: {
			background: theme.palette.colors.pru.main,
			padding: theme.spacing(2),
			maxHeight: (props: Props) => props.maxHeight ?? 'none',
			overflowY: 'scroll',
		},
		inner: {
			color: theme.palette.common.white,
			fontSize: '16px',
		},
	}),
);

export default JSONBlock;
